module.exports = __webpack_public_path__ + "static/media/premium.5768fd39.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/premium.png
// module id = 765
// module chunks = 0